(function ($, window, _, eventhub, cssCreator) {
    'use strict';

	var uid = 1;
    var pluginName = 'PMSelectGrid';
    var constants = {
    	oneRowClass     : 'oneRow',

        groupOpenClassName   : 'g_open',
		groupActiveClassName : 'g_active',
		groupUlClassName     : '_g_ul',

	    scrollableClass : 'scrollable_h',
	    iScrollClassName: 'grid_h_scroll',
	    ulClass         : 'grid_pms pm-list',
	    ulSelector      : '.grid_pms.pm-list'
    };

    var defaults = {
        enableGrouping          : false,
		enableGroupAutoClosing  : false,
	    allowActiveGroupClosing : false,

	    preventUpmAutoSelect    : false,
	    renderMpmFirst      : false,
	    oneRowRendering     : false,
	    isScrollEnabled     : false,
        showDepositAmount   : true,
        showPromoCode       : true,
        amountFieldType     : 'text',
        amountFieldInputMode: 'decimal',
	    isOpenAmount        : true,
	    scrollerSettings : {
		    className        : '.' + constants.iScrollClassName,
		    scrollX          : true,
		    scrollY          : false,
		    mouseWheel       : true,
		    scrollbars       : false, // true,
		    tap              : true,
		    shrinkScrollbars : 'scale'
	    },
        showControls            : false, // impelemented only for oneRowRendering=true
		staticControls	        : false,
	    currency                : '',
        amount                  : '',
	    isWD                    : 0,
        showUserPMs             : true,
        showMerchantPM          : true,
        pm_order_prefix         : '',
        activeElementClass      : 'selected',
        scrollMargin            : 20,
        pmWrapperClass          : 'grid_list_2',
	    itemsPerRow             : 3,
	    itemContainerTagName    : 'td', //'li',
	    onClickSelector         : 'td[data-wrapper="pm"]', // 'li[data-wrapper="pm"]',
	    allowClickSamePM        : false,
	    pminfoPlaceholderSelector: '.pm_render',
        ccCardTemplate          : '',
        showMinimumAmountLabel  : false,

        groupWrapTemplate       : '<ul class="grp "></ul>',
        groupToggleIconTemplate : '<div class="group_icon"></div>',
        
        mainTemplate        :
                '<div class="pm-grid-wrapper <%- oneRowClass%>">' +
	            '<div class="apple_pay_wrapper hidden firstTimer">' + //apple pay stuff
	                '<div class="initialApple">' +
	                    '<div class="pm-logo ppp_applepay"></div>'+
	                '</div>' +
                        '<div class="revealOtherOptions">' +
			                '<div class="btn_container">' +
				                '<div class="pm-logo other_pms">&#xe904;</div>' +
				                '<div class="text"><%- t("other_pms")%></div>' +
			                '</div>' +
                        '</div>' +
                    '</div>' +
			        '<div class="pms list-container list-pm <%-iScrollClassName%>">' +
			            '<div class="<%-pmWrapperClass%> <%-isScrollableClass%> "></div>' +
			        '</div>' +
			        '<%if(oneRowRendering){%><div class="pm_render"></div><%}%>' +
		        '</div>',
	    templates       : {
            groupingmyPMTemplate   : _.template('<div class="<%=classPrefix%> pm_container"><div class="<%-classPrefix%> pm_side_status"></div><div class="<%=classPrefix%> pm_available" title="<%=label%>"><div class="pm-logo <%-showClass%>"><% if (hasNoClass) { %><%=label%><%}%></div></div><div class="<%=classPrefix%> pm_side_status"></div></div>'),
		    
            paymentHeaderTemplate:
			    '<%if(oneRowRendering){%><ul class="grid_pms <%- ulClass%>"></ul><%}else{%><div><table class="<%- ulClass%>"></table></div><%}%>'
		    ,

            controlsTemplate: _.template("<div class='iscroll-controls-grid'><button type='button' class='left'>Left</button><button type='button' class='right'>Right</button></div>"),
            
		    pmHolderTemplate    : _.template(
			    '<<%if(oneRowRendering){%>li<%}else{%>td<%}%> data-value="<%- uniqueId %>" data-type="<%- type%>" data-wrapper="pm" >' +
                    '<div class="_li"><%=itemTemplate%></div>' +
			    '<%if(!oneRowRendering){%><div class="pm_render"></div><%}%>' +
			    '</<%if(oneRowRendering){%>li<%}else{%>td<%}%>>')
		    ,
	        pmSelectedTemplate  :
	            '<div class="section-left">' +
	                '<div class="section-header"><%- t("payment_details") %></div>' +
                        '<div class="section-content">' +
                            '<% if(hasUpos) { %><div class="allupos" data-pms-type="horizontal"></div><% } %>' +
                            '<div class="PMINFO payment_options_details"></div>' +
                            '<% if(showAddNewButton) { %>' +
                            '<div class="additional_buttons">' +
                                '<div class="add-new-pm"><%- t("add_new") %></div>' +
                                '<div class="back-to-upos"><%- t("back") %></div>' +
                            '</div>' +
                            '<% } if(!isWD) { %>' +
                            '<div id="billing_section">' +
                                '<input type="checkbox" value="None" id="user_details" name="checkbox">' +
                                '<label for="user_details"><span></span><%- t("change_billing_address") %></label>' +
                                '<div class="content_section"></div>' +
                            '</div>' +
                            '<% } %>' +
                        '</div>' +
	            '</div>' +
                '<div class="section-right">' +
			        '<div class="pm_render"></div>' +
	                '<div class="section-header" <%if (showMinimumAmountLabel) { %> id="label_open_amount_range" <% } %>> <%- t("amount") %></div>' +
                    '<div class="section-content">' +
                        '<div class="suggested-wrapper">' +
                            '<div class="payment_amount">' +
                            '<% if(!isWD) { %>' +
                                    '<div class="suggested-amounts-holder" data-mode="Table"></div>' +
                            '<% } %>' +
                                '<div class="input-wrapper">' +
                                    '<% if(!isWD) { %>' +
                                        '<div class="other_lbl "><%- t("other") %></div>' +
                                    '<% } %>' +
                                    '<div class="input-table">' +
                                        '<div class="amount-table-row">' +
                                        '<% if(!isRightPositionedCurrency){%>' +
                                            '<div class="currency-table-cell">' +
                                                '<div id="currency_lbl" class="currencyLabel"><%- currency_lbl %></div>' +
                                            '</div>' +
                                        '<% } %>' +
                                            '<div class="amount-table-cell">' +
                                                '<div class="amount-container">' +
		                                            '<% var ro = (isWD && isOpenAmount ? "" : "readonly"); var amount = isWD && !isOpenAmount ? amount_lbl : ""; %>' +
                                                    '<input type="<%- amountFieldType %>" inputmode="<%- amountFieldInputMode %>" name="item_amount_1" id="item_amount_1" class="form-control amount" autocomplete="off" maxlength="10" placeholder="<%- t(\"enter_amount\") %>" value="<%-amount%>" <%- ro%>/>' +
                                                    '<% if(isWD && defaults.config.useMaskedAmount) { %>' +
                                                        '<input type="text" inputmode="<%- amountFieldInputMode %>" name="masked_item_amount_1" id="masked_item_amount_1" class="form-control masked_amount" autocomplete="off" maxlength="10" placeholder="<%- t(\"enter_amount\") %>" value="<%-amount%>" <%- ro%>/>' +
                                                    '<% } %>' +
                                                '</div>' +
                                            '</div>' +
                                        '<% if(isRightPositionedCurrency){%>' +
                                            '<div class="currency-table-cell">' +
                                            '<div id="currency_lbl" class="currencyLabel"><%- currency_lbl %></div>' +
                                            '</div>' +
                                        '<%}%>' +
                                        '</div>' +
                                    '</div>' +
                                '</div>' +
                                '<% if(isWD) { %>' +
                                '<div id="amount_validation" class="validation_image"></div>' +
                                '<% } else { %>' +
                                '<div id="item_amount_1_validation" class="validation_image hide"></div>' +
                                '<% } %>' +
                            '</div>' +
                        '</div>' +
                        '<div id="currency_exchange_wrapper"></div>' +
                        '<%if(showPromoCode && !isWD) { %>' +
                        '<div class="promocode-wrapper">' +
                            '<input type="checkbox" value="None" id="show_promo_code" name="check">' +
                            '<label for="show_promo_code"><span></span><%- t("have_promo_code") %></label>' +
                            '<div class="row promoCode">' +
                                '<input type="text" maxlength="10" id="promoCode" name="promoCode" placeholder="<%- t(\"promo_code\") %>" value="" />' +
                                '<div id="promoCode_validation" class="validation_image invalid_field"></div>' +
                            '</div>' +
                        '</div>' +
                        '<%} if(isWD) { %>' +
                        '<button type="button" id="continueButton" class="withdraw btn btn-lg btn-primary"><span class="icon-lock">&#xe606;</span> <%- t("withdraw")%></button>' +
                        '<% } else { %>' +
                        '<button type="button" name="btnSubmit" id="continueButton" class="continue" alt="<%- t(\"deposit\")%>">' +
                            '<span class="icon-lock">&#xe606;</span>' +
                            '<%- t("deposit")%>' +
                            '<% if(showDepositAmount) { %> ' +
                                '<% if(useIntlFormatter) { %> ' +
                                '<span id="deposit-amount"><%- formattedAmount %></span>' +
                                '<% } else { %>' +
                                '<span id="deposit-currency"><%- currency_lbl %></span>' +
                                '<span id="deposit-amount"><%- amount_lbl %></span>' +
                                '<% } %>' +
                            '<% } %>' +
                        '</button>' +
                        '<% } %>' +
                    '</div>' +
	            '</div>'
        },
	    currencyMap     : {
		    'eur' : '€', 'usd' : '$', 'gbp' : '£', 'yen' : '¥', 'ils' : '₪', 'inr' : '₹', 'rub' : '₽', 'try' : '₺', 'cny' : '¥', 'krw' : '₩', 'zar' : 'R', 'brl' : 'R$'
	    },
        getIntlNumberFormatter : false,
        showApplePayInline     : false,
        reduceApplePayPriority : false
    };

    var _lastEventTimestamp;
    var handleClicks = function (mainElm, options, ctx) {

        var self 			 = ctx;
        var allowClickSamePM = options.allowClickSamePM;

        mainElm.on('click tap', options.onClickSelector, function (evt) {
            var currentTime = (new Date()).getTime();
            if (currentTime - _lastEventTimestamp < 80) { // remove ghost click events
                _lastEventTimestamp = currentTime;
                return true;
            }
            var $tdElm = $(evt.target).closest(options.itemContainerTagName);

            var uniqueId = $tdElm.data('value');
            var isAlreadySelected = $(evt.target).closest(options.itemContainerTagName).hasClass(options.activeElementClass);
            var pminfoPlaceholderSelector = (options.oneRowRendering) ? options.pminfoPlaceholderSelector : options.pminfoPlaceholderSelector + ' > td';

            if (self.Groups && self.Groups[uniqueId]) {
				self.manageGroupedPMs(uniqueId, $tdElm);
				_lastEventTimestamp = currentTime;
				return;
			}


            if (!isAlreadySelected || allowClickSamePM) {
	            var $parentRow = $(this).parents('tr');
                mainElm.find('.' + options.activeElementClass).removeClass(options.activeElementClass);
                if (options.oneRowRendering) {
                    // do nothing
                } else  if ($parentRow.next(options.pminfoPlaceholderSelector).length) {
	                $(pminfoPlaceholderSelector).empty();
                } else {
                    $(options.pminfoPlaceholderSelector).remove();
                    $parentRow.after('<tr class="' + options.pminfoPlaceholderSelector.substr(1) + '"><td colspan="' + options.itemsPerRow + '"></td></tr>');
                }

                var currentItem = self.gridPMs[uniqueId];
                var hasUpos, showAddNewButton, renderPM, formattedAmount, isRightPositionedCurrency = false;

                if (currentItem) {
                    if (currentItem.user_pm.length) {
                        hasUpos = true;
                    }
                    if (currentItem.pm.length) {
                        showAddNewButton = true;
                        self.selectedPM = currentItem.pm[0];
                        self.selectedPM.pmPosition = self.order[uniqueId];
                    }
                    if (!currentItem.user_pm.length && currentItem.pm.length) {
                        showAddNewButton = false;
                        renderPM = true;
                    }
                }
                var tpl =  _.template(options.templates.pmSelectedTemplate);
                var currency_lbl = options.currency;
	            if ( options.currencyMap[currency_lbl.toLowerCase()] ) {
		            currency_lbl = options.currencyMap[currency_lbl.toLowerCase()]
	            }

                if (options.intlFormatter && options.intlFormatter.formatCurrency) {
                    formattedAmount = options.intlFormatter.formatCurrency(options.amount, options.currency);
                    currency_lbl = options.intlFormatter.getCurrencySymbol(options.currency);
                    isRightPositionedCurrency = options.intlFormatter.isRightPositionedCurrency(options.currency);
                } else {
                    formattedAmount = currency_lbl + ' ' + options.amount;
                }
                $(pminfoPlaceholderSelector).html(tpl({
                	'hasUpos': hasUpos,
	                'showAddNewButton': showAddNewButton,
	                'isWD': options.isWD ,
	                'useIntlFormatter': !!options.intlFormatter,
	                'isRightPositionedCurrency': isRightPositionedCurrency,
                    'showDepositAmount': options.showDepositAmount,
                    'showPromoCode': options.showPromoCode,
                    'amountFieldType': options.amountFieldType,
                    'amountFieldInputMode': options.amountFieldInputMode,
                    'isOpenAmount': options.isOpenAmount,
                    'amount_lbl': options.amount,
                    'currency_lbl': currency_lbl,
                    'formattedAmount': formattedAmount,
                    'showMinimumAmountLabel': options.showMinimumAmountLabel
                }));

                if (hasUpos) {
                    var pmSelectHOpt = $.extend(true, {}, app.pluginOpts.PMSelectH);
                    pmSelectHOpt.pm_order_prefix = self.order[uniqueId].absolute + (self.selectedPM && self.selectedPM.groupId ? '' : '.0');
                    self.plugin_H = $('div[data-pms-type="horizontal"]').PMSelectH(pmSelectHOpt).data('plugin_PMSelectH');
	                var user_pm_data = $.extend(true, {}, currentItem.user_pm);
	                self.plugin_H.updateData('user_pm', user_pm_data);
                    if(!options.preventUpmAutoSelect &&  !app.submittedMethod){
	                    self.plugin_H.handleDR("auto_select", "auto_select");
                    }
                }

                var currData = self.gridPMs[uniqueId].pm[0];

                self.updateCurrentState(currData, $tdElm);
                self.unselect(true);
                self.select($tdElm);

                if (renderPM) {
                    eventhub.publish('select-pm', [currData, self, this]);
                }
            } else {
                eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason:"already_selected"}, self, this]);
            }
            _lastEventTimestamp = currentTime;
            evt.preventDefault();
        });
    };
	function _normalizePluginOptions(ctx){
		ctx.options.scrollerSettings.className = ctx.options.scrollerSettings.className + '_' + uid;
		if(ctx.options.oneRowRendering) {
			if (ctx.options.itemContainerTagName === 'td') {
				ctx.options.itemContainerTagName = 'li';
				var selector_str = ctx.options.onClickSelector;
				_.each(selector_str.match(/^(td)[.\s\[>+]|[\s+>](td)[.\s\[>+]/g), function (m) {
					var x = m.replace('td', 'li');
					selector_str = selector_str.replace(m, x)
				});
				ctx.options.onClickSelector = selector_str;
			}
			ctx.options.isScrollEnabled = true;
		} else {
			ctx.options.isScrollEnabled = false;
		}
        if (ctx.options.getIntlNumberFormatter && typeof ctx.options.getIntlNumberFormatter == 'function') {
            ctx.options.intlFormatter = ctx.options.getIntlNumberFormatter();
        }
	}
    function Plugin(element, options) {
        options       = options || {};
        this.$element = $(element);
		this.updateControlButtons = function () {/* This is intentional*/};
        if(!options.onClickSelector && options.itemContainerTagName) {
            options.onClickSelector = options.itemContainerTagName;
        }
        this.options  = $.extend(true, {}, defaults, options);
        this.init();

    }

    Plugin.prototype.init = function () {
	    this.hasApplePay = false;

        var self = this;
	    var iScrollClassName = constants.iScrollClassName + '_' + uid;
	    _normalizePluginOptions(this);
        cssCreator.setup(this.options.cssCreator);
        if(this.options.showMerchantPM) {
            eventhub.subscribe('pm-available', function (data) {
	            self.updateData('pm', data);
            }, this);
        }
        if(this.options.showUserPMs) {
            eventhub.subscribe('user-pm-available', function (data) {
	            self.updateData('user_pm', data);
            }, this);
        }
        eventhub.subscribe('dr-select-pm', function (data) {
            var uniqueId = (data.type && data.type === 'int') ? parseInt(data.uniqueId, 10) : data.uniqueId;
            this.handleDR(uniqueId, data.type, data.manual, data.allowApplePayAutoSelect);
        }, this);
        eventhub.subscribe('app.event.DepositClicked', function () {
            $('#item_amount_1_validation').removeClass('hide-amount-error');
        });

	    this.$main_wrapper = $( _.template(self.options.mainTemplate)({
		    iScrollClassName: iScrollClassName,
		    isScrollableClass: (self.options.isScrollEnabled ? constants.scrollableClass : '' ),
		    oneRowClass     : (self.options.oneRowRendering ? constants.oneRowClass : '' ),
		    oneRowRendering : self.options.oneRowRendering,
		    pmWrapperClass  : self.options.pmWrapperClass
	    }) );
	    this.$element.append(self.$main_wrapper);


        this.$main_wrapper.on('click', '.add-new-pm', function() {
	        eventhub.publish('select-pm', [self.selectedPM, self]);
			self.plugin_H.unselect();
            $('.allupos').hide();
            $('.add-new-pm').hide();
            $('.back-to-upos').show();
        });
        this.$main_wrapper.on('click', '.back-to-upos', function() {
	        self.plugin_H.handleDR("auto_select", "auto_select");
            $('.allupos').show();
            $('.add-new-pm').show();
            $('.back-to-upos').hide();
        });
        this.$main_wrapper.on('click', '.other_lbl', function() {
            app.util.setAmountValue('', []);
            if($('#masked_item_amount_1').is(':visible')) {
                $('#masked_item_amount_1').focus();
            } else {
                $('input#item_amount_1').focus();
            }
            $(this).addClass('hide');
        });
        this.$main_wrapper.on('blur', '#item_amount_1, #masked_item_amount_1', function() {
            if (!$(this).val().length) {
                $('.other_lbl').removeClass('hide');
                $('#item_amount_1_validation').addClass('hide-amount-error');
            }
        });

	    this.$wrapper = $('.' + self.options.pmWrapperClass, self.$main_wrapper );
        handleClicks(this.$wrapper, this.options, this);
        this.gridPMs = {};

        if(this.options.oneRowRendering) {
            if(self.options.showControls){
		        _setupControls(self);
	        }
            $(window).resize( function(){
                self.updateScroll();
    	        self.updateControlButtons();
            });
        }

	    if(this.options.isScrollEnabled) {
	    	var elm = $('.' + iScrollClassName, self.$main_wrapper)[0];
	    	if(elm) {
			    this.iScroll = new IScroll(elm, self.options.scrollerSettings);
		    }
	    }

	    pubsub.subscribe('app.event.PMSelectGrid.unselectPM', function() {
            self.unselect();
        });

	    if (this.options.showDepositAmount) {
	        var opt = this.options;
            pubsub.subscribe('app.event.AmountChange', function(newValue){
                self.updateAmountAndCurrency(newValue, opt);
            });
            pubsub.subscribe('app.event.RestrictionsApplied', function(newValue) {
                self.updateAmountAndCurrency(newValue, opt);
            });
            pubsub.subscribe('post-pm-render' , function (data) {
                var amount = $('#item_amount_1').val();
                self.updateAmountAndCurrency(amount, opt);
            });
            pubsub.subscribe('post-upm-render' , function (data) {
                var amount = $('#item_amount_1').val();
                self.updateAmountAndCurrency(amount, opt);
            });
        }

	    $('div.revealOtherOptions').on('click',function(){
            self.$main_wrapper.find('.apple_pay_wrapper').addClass('hidden');
            self.$main_wrapper.find('.pms.list-container.list-pm').removeClass('hidden');

            if(self.options.oneRowRendering) {
                self.updateWidth();
            }
	    });
    };

    Plugin.prototype.select = function ($liElm) {
        var self = this;
	    var groupId = (self.selected && self.selected.groupId);
	    $liElm.addClass(self.options.activeElementClass);
	  
	    // GROUPS
	    if (self.options.enableGrouping && self.Groups && groupId) {
		    self.Groups[groupId].$elm.addClass(constants.groupActiveClassName);
		    if (self.options.allowActiveGroupClosing && self.options.enableGroupAutoClosing) {
			    self.closeGroup(groupId);
		    } else if(self.selected && self.selected.$elm.hasClass('hidden')){
			    self.openGroup(groupId);
		    }
	    }
    };
    
	Plugin.prototype.unselect = function(isCurrentStateUpdated) {
        this.$wrapper.find('.' + this.options.activeElementClass).removeClass(this.options.activeElementClass);
        var self = this;

        if(!isCurrentStateUpdated){
		    self.updateCurrentState();
	    }
	    // GROUPS
	    if (self.options.enableGrouping) {
		    var $activeGroupElm = self['$pms'].find('.' + constants.groupActiveClassName),
			    groupIsOpen, lastActiveGroupId;
		    if ($activeGroupElm.length) {
			    groupIsOpen = $activeGroupElm.hasClass(constants.groupOpenClassName);
			    lastActiveGroupId = $activeGroupElm.attr('data-value');
			    $activeGroupElm.removeClass(constants.groupActiveClassName);
			    if (!groupIsOpen && (self.selected && self.selected.groupId !== lastActiveGroupId)) {
				    self.closeGroup(lastActiveGroupId);
			    }
		    }
	    }
    };

	Plugin.prototype.updateAmountAndCurrency = function (newValue, opt) {
        var currency = app.lastSelectedCurrency;
        if (opt.intlFormatter) {
            $('#deposit-amount').html(opt.intlFormatter.formatCurrency(newValue, currency));
        } else {
            if (opt.currencyMap[app.lastSelectedCurrency.toLowerCase()]) {
                currency = opt.currencyMap[currency.toLowerCase()]
            }
            if ($('#deposit-currency').html() !== currency) {
                $('#deposit-currency').html(currency);
            }
            $('#deposit-amount').html(newValue);
        }
        if ((!$('#item_amount_1').is(':focus') && !$('#masked_item_amount_1').is(':focus')) && app.currentValue != newValue) {
            $('.other_lbl').removeClass('hide');
            $('#item_amount_1_validation').addClass('hide-amount-error');
        }
        if (newValue == 0) {
            $('#deposit-currency, #deposit-amount').html('');
        }
        app.currentValue = newValue;
    };

    Plugin.prototype.handleDR = function (uniqueId, idType, manual, allowApplePayAutoSelect) {
	    var self = this;
	    var $el;
	    var doSelectApplePayBtn = (self.hasApplePay && allowApplePayAutoSelect
            && !self.$main_wrapper.find('.apple_pay_wrapper').hasClass('firstTimer')
            && (!(self.options.user_pm_data && self.options.user_pm_data.length) || !self.options.reduceApplePayPriority)
        );

        if(!doSelectApplePayBtn && self.$main_wrapper.find('.pms.list-container.list-pm').hasClass('hidden')){
            /** show entire gallery */
            self.$main_wrapper.find('div.revealOtherOptions').trigger('click');
        }

	    // if (self.hasApplePay && allowApplePayAutoSelect && !$('.apple_pay_wrapper').hasClass('firstTimer')) {
        if(doSelectApplePayBtn){
		    $el = $( this.options.itemContainerTagName + '[data-value=ppp_ApplePay][data-type="pm"]' );
		    $el.trigger('click');
            if (this.iScroll) {
                this.iScroll.scrollToElement($el[0]);
            }
		    setTimeout(function(){ $('.add-new-pm').trigger('click', manual); },10);
		    return;
	    } else if(uniqueId === "auto_select" && idType === "auto_select"){

            $el = $( this.options.onClickSelector ).first();
	        $el.trigger('click');
	        return;
        } else if(uniqueId === "auto_select" && idType === "pm"){
            $el = $( this.options.itemContainerTagName + '[data-value][data-type="pm"]' ).first();
	        $el.trigger('click');
	        return;
        } else {
	        if(idType === 'int' && this.user_pm_by_ID && this.user_pm_by_ID[uniqueId] && this.user_pm_by_ID[uniqueId].parent){
		        var wrapperID = this.user_pm_by_ID[uniqueId].parent;
                $el = $(this.options.itemContainerTagName + '[data-value=' + wrapperID + '][data-wrapper="pm"]');
		        if($el.length) {
			        var eventhubObject = eventhub.subscribe('app.event.pmselecth.postRender', function (data) {
				        this.plugin_H.handleDR(uniqueId, idType);
				        eventhub.unsubscribe(eventhubObject);
			        }, this);
			        $el.trigger('click');

                    if (this.iScroll) {
                        this.iScroll.scrollToElement($el[0]);
                    }
			        return;
		        }
	        } else if(this.gridPMs[uniqueId] && this.gridPMs[uniqueId].pm.length){
		        $el = $( this.options.itemContainerTagName + '[data-value=' + uniqueId + '][data-type="pm"]' );
		        $el.trigger('click');
                if (this.iScroll) {
                    this.iScroll.scrollToElement($el[0]);
                }
		        setTimeout(function(){ $('.add-new-pm').trigger('click', manual); },10);
		        return;
	        }
        }
        eventhub.publish('select-pm-attempt', [{uniqueId : uniqueId, reason:"incorrect_id"}, self, this]);
    };

    Plugin.prototype.updateWidth = function () {
        function _setElmWidth($el) {
			var w = 0, blw, brw;
			$el.children().each(function () {
				var $this = $(this);
				if (!$this.hasClass('hidden')) {
					w += $this.outerWidth(true);
				}
			});
			blw = parseFloat($el.css('border-left-width'));
			brw = parseFloat($el.css('border-right-width'));
			w += (blw || 0) + (brw || 0);
			$el.css('width', Math.ceil(w) + 'px');
			return w;
		}

        var self = this;
        var totalLength = 0;
        self.$wrapper.find('> ul >' + self.options.itemContainerTagName).each(function (){
            var $this = $(this);
			if (self.options.enableGrouping && $this.hasClass('pm_group')) { 
				var $ul = $this.find('[data-role="groupItemsHolder"]');
				_setElmWidth($ul);
				_setElmWidth($this)
			}

            totalLength += $(this).outerWidth(true);
        });
        self.$wrapper.css('width', Math.ceil(totalLength) + 'px');
    };

    Plugin.prototype.updateScroll = function () {
		var self = this;
		self.updateWidth();
		var fakeScrollObj = function () {
			this.isFake = true;
			this.refresh = _.identity;
			this.scrollToElement = _.identity;
			this.scrollTo = _.identity;
			this.destroy = _.identity;
			this.scrollBy = _.identity;
			this.on = _.identity;
		};
		var pmScroller = self.iScroll;
        
        var $listContainer = $('.grid_h_scroll_1');
        var listContainer = $listContainer[0];
		if (pmScroller && !pmScroller.isFake) {
			var $wrapper = $(pmScroller.wrapper);
			var parent = $wrapper.parent();
			pmScroller.refresh();
			if (pmScroller.scrollerWidth > $wrapper.width()) {
				$('.iScrollLoneScrollbar', parent).show();
			} else {
				$('.iScrollLoneScrollbar', parent).hide();
				pmScroller.destroy();
				self.iScroll = new fakeScrollObj(listContainer, self.options.scrollerSettings);
			}
		} else if (self.options.isScrollEnabled  && (self.$wrapper.width()  > $listContainer.width())) { // self.wrapper.width() > self.$element.width()
			self.iScroll = new IScroll(listContainer, self.options.scrollerSettings);
		} else {
			self.iScroll = new fakeScrollObj(listContainer, self.options.scrollerSettings);
		}

        self.updateControlButtons();
		_addScrollEndListener(self);
	};

    function _addScrollEndListener( self ) {
		if (self.iScroll && !self.iScroll._scrollEndEventAttached) {
			self.iScroll.on('scrollEnd', function () {
				self.iScroll._scrollEndEventAttached = true;
                self.updateControlButtons();
			});
		}
	}

    Plugin.prototype.updateGroupsDomRef = function () {
		var self = this;
		if (self.options.enableGrouping && self.Groups) {
			_.each(self.Groups, function (group) {
				if (group && !group.$elm) {
					group.$elm = self['$pms'].find(self.options.itemContainerTagName + '[data-value="' + group.uniqueId + '"]');
					group.$elms = self['$pms'].find(self.options.itemContainerTagName + '[data-group="' + group.uniqueId + '"]');
				}
			});
		}
	};

    Plugin.prototype.updateCurrentState = function (data, liElm) {
		var self = this;
		if (data) {
			self.selected = $.extend(true, {}, data);
			self.selected.$elm = liElm;
			self.selected.$groupElm = self.Groups && data.groupId && self.Groups[data.groupId] && self.Groups[data.groupId].$elm;
		} else {
			self.selected = {};
		}
	};

    Plugin.prototype.render = function (currentListElm, data_type, currData) {
		function _renderItem(item, data_type, tpl) {
			var $elm = $(self.options.templates.pmHolderTemplate({
				uniqueId       : item.uniqueId,
				itemTemplate : tpl(item),
				type         : data_type,
                oneRowRendering: self.options.oneRowRendering
			}));
			if (item.groupId) {
				$elm.attr('data-group', item.groupId).addClass('hidden');
			}
			if (item.isPmGroup) {
				$elm.addClass('pm_group');
			}
			
			return $elm;
		}

		function _appendTo(parent, elm) {
			if (self.options.direction === 'rtl') {
				parent.prepend(elm);
			} else {
				parent.append(elm);
			}
		}

        function _createTableRow () {
            return $('<tr></tr>');
        }

		function _listItems(docFragment, data, data_type, isGroupMember) {
			var itemContentTemplate =  (_.isString(self.options.templates.groupingmyPMTemplate) ? _.template(self.options.templates.groupingmyPMTemplate) : self.options.templates.groupingmyPMTemplate)
            var $tableRow;
            if(!self.options.oneRowRendering) {
                $tableRow = _createTableRow();
            }

            _.each(data, function (key, idx) {
                var item;
                if(isGroupMember) {
                    item = key;
                } else {
                    item = self.gridPMs[key].pm[0];
                    if(!item){
                        item = {
                            details     : '',
                            isIframe    : false,
                            name        : key,
                            uniqueId    : key,
                            label       : key
                        };
                    }
    
                    item.hasNoClass  = !cssCreator.makeRule(item.name.toLowerCase());
                    item.classPrefix = 'pm';
                    if(item && !item.isPmGroup) {
                        item.showClass   = item.name.toLowerCase();
                    }

                    item.type        = data_type;
                    item.oneRowRendering = self.options.oneRowRendering;
                }
               

				var elm;
                switch (data_type) {
					case 'user_pm':
						if (item.imgUrl) {
							var cssObj = self.options.customCssObjCreator(item.imgUrl, item.showClass);
							cssCreator.addCustomRule(item.showClass + self.options.customCssRuleSelectorSufix, cssObj);
						} else {
							cssCreator.makeRule(item.showClass);
						}
						break;
					case 'pm':
						item.hasNoClass = (item.showClass === 'cc_card' || item.showClass === 'dc_card') ? false : !cssCreator.makeRule(item.showClass);
						break;
				}

				if (isGroupMember || !item.groupId) {
					elm = _renderItem(item, data_type, itemContentTemplate);
                    if(!self.options.oneRowRendering) {
					    _appendTo($tableRow, elm);
                        if (idx && (idx + 1) % self.options.itemsPerRow == 0) {
                            _appendTo(docFragment, $tableRow);
                            $tableRow = _createTableRow();
                        }
                    } else {
                        _appendTo(docFragment, elm);
                    }
				}
				if (item.isPmGroup && item.pm_list) {
					var df2 = $(document.createDocumentFragment()), ul;
					_listItems(df2, item.pm_list, data_type, true);

					ul = $(self.options.groupWrapTemplate)
						.attr('data-role', 'groupItemsHolder').addClass(constants.groupUlClassName)
						.append(df2);

					elm.attr('data-items', item.pm_list.length)
						.addClass('pms_wrap_' + item.pm_list.length);

					_appendTo(elm, ul);
					_appendTo(elm, $(self.options.groupToggleIconTemplate).attr('data-role', 'group_icon'));
				}
			});
		}

		var self = this;
		var dir = self.options.direction;
        
		var currentData = currData || [];
		if (currentListElm) {
			currentListElm.find(self.options.itemContainerTagName + '[data-type="' + data_type + '"]').remove();
			var docFragment = $(document.createDocumentFragment());
			_listItems(docFragment, currentData, data_type);

            if ((data_type === 'pm' && dir === 'rtl') || (data_type === 'user_pm' && dir !== 'rtl')) {
				currentListElm.prepend(docFragment);
			} else {
				currentListElm.append(docFragment);
			}
		}
	};

    Plugin.prototype.updatePmPosition = function () {
        var self = this;
        var order = {};
        var items = self.$pms.find(self.options.itemContainerTagName + '[data-value]').not("[data-group]");
        _findOrder(items, self.options.pm_order_prefix);
        self.order = order;

        function _findOrder(items, prefix, subPrefix) {
            prefix = prefix ? prefix + "." : '';
            subPrefix = subPrefix ? subPrefix + "." : '';
            var count = 0;
            var upoCount = 0;
            var arr = (self.options.direction === 'rtl') ? items.toArray().reverse() : items.toArray();
            _.each(arr, function (item, idx) {
                var $i = $(item);
                var id = $i.attr("data-value");
                var isUpo = $i.attr("data-type") === "user_pm";
                var pos, subPos;
                if (isUpo) {
                    pos = prefix + (++count);
                    subPos = '' + (++upoCount);// prefix + (++upoCount);//
                } else {
                    pos = prefix + (id === 'ppp_ApplePay' && !self.options.showApplePayInline ? '0' : ++count);
                    subPos = (id === 'ppp_ApplePay' && !self.options.showApplePayInline) ? '0' : subPrefix + (count - upoCount);
                }
                order[id] = {absolute: pos, relative: subPos};
                if ($i.hasClass("pm_group")) {
                    var pms = $i.find(self.options.itemContainerTagName + '[data-group="' + id + '"]');
                    _findOrder(pms, pos, subPos);
                }
            });
        }
    };

    Plugin.prototype.updateData = function (data_type, data) {
	    data = data || [];
	    var self = this;
        var currentData = null;
        if (data_type === "pm") {
            if (!self.options.showApplePayInline) {
                self.hasApplePay = _.findIndex(data, function (item) {
                    return item.value === "ppp_ApplePay"
                }) > -1;
                var $appleNav = self.$main_wrapper.find('.apple_pay_wrapper');
                if (self.hasApplePay && $appleNav.hasClass('firstTimer')) {
                    $appleNav.removeClass('hidden firstTimer');
                    self.$main_wrapper.find('.pms.list-container.list-pm').addClass('hidden');
                }
            }
            currentData = self.pm(data);
        } else if(data_type === "user_pm"){
            currentData = data;
	        _.each( self.gridPMs , function (item, key){
                if( !self.gridPMs[key].pm.length ){
	               delete self.gridPMs[key];
                } else {
                    self.gridPMs[key].user_pm = [];
                }
            });
        }
	    $(this.options.pminfoPlaceholderSelector, this.$wrapper).remove();
        this.options[data_type + '_data'] = currentData;
	    var paymentHeaderTemplate = _.template(this.options.templates.paymentHeaderTemplate);
        if(_.size(currentData) && !this.$wrapper.find(constants.ulSelector).length) {
            this.$wrapper.append(paymentHeaderTemplate({ulClass: constants.ulClass, oneRowRendering: self.options.oneRowRendering}));
            this['$pms'] = this.$wrapper.find(constants.ulSelector);
        }
        var currentListElm = this['$pms'];
        if(currentListElm){
            currentListElm.empty();

            if(data_type === "pm"){
		        self.ordered_pm_names = [];
	        } else if (data_type === "user_pm" ){
		        self.only_user_pm_names = [];
		        self.user_pm_by_ID = {};
	        }

            _.each(currentData, function(val) {
                if (self.gridPMs && val && (val.paymentOptionName || val.uniqueId)) {
                    var name = val.paymentOptionName || val.uniqueId;
	                if(data_type === "pm"){
		                self.ordered_pm_names.push(name);
	                } else if (data_type === "user_pm"){
	                	self.user_pm_by_ID[val.userPaymentOptionId] = val;
	                	self.user_pm_by_ID[val.userPaymentOptionId].parent = name;
		                if (!self.gridPMs[name]) {
			                self.only_user_pm_names.push(name);
		                }
	                }
                    if (!self.gridPMs[name]) {
                        self.gridPMs[name] = {
                            user_pm: [],
                            pm: []
                        };
                    } else if(data_type === "pm"){
	                    self.gridPMs[name].pm = [];
                    }
                    self.gridPMs[name][data_type].push(val);
                }
            });
	        self.ordered_pm_names   = self.ordered_pm_names || [];
	        self.only_user_pm_names = self.only_user_pm_names || [];

	        var ordered_pms = (self.options.renderMpmFirst) ? _.uniq(self.ordered_pm_names.concat(self.only_user_pm_names)) : _.uniq(self.only_user_pm_names.concat(self.ordered_pm_names));
            if (!self.options.showApplePayInline) {
                var applePayObj = _.remove(ordered_pms, function (pmname) {
                    return (pmname === 'ppp_ApplePay');
                });
                if (applePayObj.length) {
                    ordered_pms.unshift(applePayObj[0]);
                }
            }
            self.render(currentListElm, data_type, ordered_pms);
            self.updateGroupsDomRef();
            self.updatePmPosition();
        }

        if(self.options.oneRowRendering && self.options.isScrollEnabled) {
            self.updateScroll();
        }

        $('.pm-logo.cc_card, .pm-logo.dc_card', this.$wrapper).html(this.options.ccCardTemplate);
        if (data_type !== 'user_pm') {
            eventhub.publish('app.event.PMSelectGrid.postRender', [{data_type: data_type}]);
            eventhub.publish('app.event.gallery.postRender', [{data_type: data_type, plugin: 'pmselectgrid'}]);
        }
    };

    Plugin.prototype.pm = function (merchantPMArray) {
        var retObj = {},
            self = this;

        self.Groups = {};
        _.each(_.map(merchantPMArray, function (item) {
            var iframe = null;
            if (item.attributes && _.has(item.attributes, 'isIframe')) {
                iframe = item.attributes.isIframe;
            }
            var showClass = item.value || '';
            showClass = showClass.toLowerCase();
            var details   = "";
            var fee = item.attributes.customFees || {};

            if (item.groupId && !self.Groups[item.groupId]) {
				self.Groups[item.groupId] = _createGroup(item);
			}

            return {
                uniqueId     : item.value,
                label        : item.label,
                name         : showClass,
                isIframe     : iframe,
                showClass    : showClass,
                details      : details || '',
                feeValue     : fee.feeValue ,
                feeValueType : fee.feeValueType ,
                feeType      : fee.feeType ,
	            feeMinValue  : fee.feeMinValue ,
	            feeMaxValue  : fee.feeMaxValue ,
                rawData      : item  || {},
				classPrefix  : 'pm',
                groupId      : self.options.enableGrouping && item.groupId
            };
        }), function (elm) {
            if (self.options.enableGrouping && elm.groupId && self.Groups[elm.groupId]) {
				if (!retObj[elm.groupId]) {
					retObj[elm.groupId] = self.Groups[elm.groupId];
				}
				retObj[elm.groupId].pm_list.push(elm);
			}
			retObj[elm.uniqueId] = elm;
        });

        return retObj;
    };

    function _setupControls (self) {
        var $gridContainer    = $('.pm-grid-wrapper');
		var $listContainer =    $('.grid_h_scroll_1');
		var margin = self.options.scrollMargin;
		var duration = 1000;
		var easing = IScroll.utils.ease.quadratic;

		var showHideControls = function () {
			if (self.iScroll) {
				self.iScroll.refresh();
				if (self.iScroll.scrollerWidth > $listContainer.width()) {
					$gridContainer.find('.iscroll-controls-grid').show();
					if (self.options.staticControls) {
						$listContainer.addClass('iscroll-controls-grid-static');
					}
				} else {
					$gridContainer.find('.iscroll-controls-grid').hide();
					$listContainer.removeClass('iscroll-controls-grid-static');
				}
			}
		};

		var buttonsState = function () {
			if (self.iScroll) {
				self.iScroll.refresh();
				var $left = $gridContainer.find('.iscroll-controls-grid .left');
				var $right = $gridContainer.find('.iscroll-controls-grid .right');
				if (self.iScroll.x == 0) {
					$left.attr('disabled', true);
					$right.attr('disabled', false);
				}
				if (self.iScroll.x > self.iScroll.maxScrollX && self.iScroll.x != 0) {
					$left.attr('disabled', false);
					$right.attr('disabled', false);
				}
				if (self.iScroll.x == self.iScroll.maxScrollX) {
					$left.attr('disabled', false);
					$right.attr('disabled', true);
				}
			}
		};

		self.updateControlButtons = function () {
			if (self.options.showControls) {
				showHideControls();
				buttonsState();
			}
		};

		$gridContainer.on('click', '.iscroll-controls-grid .left', function () {
			if (self.iScroll.x + self.iScroll.wrapperWidth >= 0) {
				self.iScroll.scrollTo(0, 0, duration, easing);
				$gridContainer.find('.iscroll-controls-grid .left').attr('disabled', true);
				$gridContainer.find('.iscroll-controls-grid .right').attr('disabled', false);
			} else {
				self.iScroll.scrollBy(self.iScroll.wrapperWidth - margin, 0, duration, easing);
			}
			$gridContainer.find('.iscroll-controls-grid .right').attr('disabled', false);
		});

		$gridContainer.on('click', '.iscroll-controls-grid .right', function () {
			if (self.iScroll.x - self.iScroll.wrapperWidth <= self.iScroll.maxScrollX) {
				self.iScroll.scrollTo(self.iScroll.maxScrollX, 0, duration, easing);
				$gridContainer.find('.iscroll-controls-grid .right').attr('disabled', true);
			} else {
				self.iScroll.scrollBy(-self.iScroll.wrapperWidth + margin, 0, duration, easing);
			}
			$gridContainer.find('.iscroll-controls-grid .left').attr('disabled', false);
		});

		if (!$gridContainer.find('.iscroll-controls-grid').length) {
			var controls = self.options.templates.controlsTemplate;
			    $gridContainer.append(controls);

			if (self.options.staticControls) {
				$listContainer.addClass('iscroll-controls-grid-static');
			}
		}

		showHideControls();
		buttonsState();
	}

    function _createGroup(item) {
		return {
			uniqueId    : item.groupId,
			label       : item.groupLabel,
			name        : item.groupLabel,
			showClass   : (item.groupShowClass || item.groupLabel).toLowerCase(),
			isPmGroup   : true,
			isIframe    : false,
			details     : '',
			classPrefix : 'pm',
			pm_list     : [],
			$elm        : false,
			$elms       : false,
			groupId     : false,
			rawData     : {}
		}
	}

    Plugin.prototype.closeGroup = function (groupId) {
		var self = this;
		if (groupId && self.Groups && self.Groups[groupId]) {
            self.Groups[groupId].$elm.removeClass(constants.groupOpenClassName);
			self.Groups[groupId].$elms.addClass('hidden');

			if (self.selected && self.selected.groupId === groupId) {
				self.selected.$elm.removeClass('hidden');

                if (this.iScroll) {
                    this.iScroll.scrollToElement(self.Groups[groupId].$elm[0]);
                }
			}
			self.updateScroll();
		}
	};

	Plugin.prototype.openGroup = function (groupId) {
		var self = this;
		if (groupId && self.Groups && self.Groups[groupId]) {
            self.Groups[groupId].$elm.addClass(constants.groupOpenClassName);
			self.Groups[groupId].$elms.removeClass('hidden');

			self.updateScroll();
		}
	};

	Plugin.prototype.manageGroupedPMs = function (groupId, $liGroupElm) {
		var self = this;
		if (groupId && self.Groups[groupId] && self.Groups[groupId].pm_list.length) {
			if ($liGroupElm && $liGroupElm.hasClass(constants.groupOpenClassName)) {
				if (self.options.allowActiveGroupClosing || (self.selected && self.selected.groupId !== groupId)) {
					self.closeGroup(groupId);
				}
			} else {
				self.openGroup(groupId)
			}
		}
	};

    /**
     * Plugin initialization
     * @param options
     * @returns {*}
     */
    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Plugin(this, options));
	            uid += 1;
            }
        });
    };
})(jQuery, window, _, pubsub, cssCreator);